export enum EntityType {
  Player,
  Heart,
  Mcguffin,
  Goblin,
  GoblinArcher,
  Projectile,
  Exit,
  Spikes,
  Grenade,
  Explosion,
  GrenadePickup,
  Floater,
}
